import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppConfig } from '../../../config/app-config';
import { Logout } from '../../../auth/store/actions/auth.actions';
import * as fromApp from '../../../shared/store/app.reducer';
import { Router } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  @Input() imageHref: string;

  env = AppConfig.settings.env;

  isAuthenticated = false;
  userInfo = null;
  authState: Observable<any>;
  pipMailingState: Observable<any>;
  lmsState: Observable<any>;
  imagePath = null;
  isLoading: boolean;

  constructor(
    private store: Store<fromApp.AppState>,
    private breakpointObserver: BreakpointObserver
  ) {
    this.authState = this.store.select('auth');
  }

  get isMobile$(): Observable<boolean> {
    return this.breakpointObserver
      .observe('(max-width: 768px)')
      .pipe(map((result) => result.matches));
  }

  ngOnInit() {
    this.authState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.userInfo = state.userInfo;
      this.isLoading = state.isLoading;
    });
    this.imagePath = this.env.logoFile;
    console.log('imagePath ->' + this.imagePath);
  }

  logout() {
    this.store.dispatch(new Logout());
  }

  navigateToImageHref() {
    this.isMobile$
      .pipe(
        take(1),
        map((isMobile) => {
          if (!isMobile) {
            window.location.href = this.imageHref;
          }
        })
      )
      .subscribe();
  }
}
